module.exports = __webpack_public_path__ + "img/revistas_governanca.67054360.png";